export default __webpack_public_path__ + "static/media/the-brilliance-original-mixtape.a5e3228d.jpg";